import { displayUrl, toFullUrl } from "../utils/urlForm";

/** Single text field for URLs — no https:// dropdown. Auto-prepends https:// on change. */
export default function SimpleUrlInput({
  value,
  onChange,
  disabled = false,
  required: isRequired = false,
  placeholder = "your-website.com",
  className = "",
  style,
  id,
  "aria-label": ariaLabel = "Website URL",
  onKeyDown,
}) {
  const handleClear = () => {
    onChange("");
  };

  return (
    <div style={{ position: "relative", display: "inline-flex", width: "100%", alignItems: "center" }}>
      <input
        id={id}
        className={`input tool-url-input ${className}`.trim()}
        type="text"
        inputMode="url"
        autoComplete="url"
        placeholder={placeholder}
        value={displayUrl(value)}
        onChange={(e) => onChange(toFullUrl(e.target.value))}
        onKeyDown={onKeyDown}
        disabled={disabled}
        required={isRequired}
        aria-label={ariaLabel}
        spellCheck={false}
        style={{
          ...style,
          width: "100%",
          paddingRight: value ? "32px" : "12px",
        }}
      />
      {value && !disabled && (
        <button
          type="button"
          onClick={handleClear}
          style={{
            position: "absolute",
            right: "10px",
            background: "none",
            border: "none",
            color: "var(--text-muted, #64748b)",
            fontSize: "14px",
            cursor: "pointer",
            padding: "4px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            lineHeight: 1,
            userSelect: "none",
          }}
          aria-label="Clear input"
        >
          ✕
        </button>
      )}
    </div>
  );
}
